module.exports = __webpack_public_path__ + "img/574a98d.jpg";